__turbopack_context__.v({
  "footer": "ArticleFooter-module-scss-module__06uZQW__footer",
  "social-plug": "ArticleFooter-module-scss-module__06uZQW__social-plug",
});
